import React from "react";
import logo from "../../assets/images/logo.png";
import { Spinner } from "react-bootstrap";
import "./Loader.scss";

const Loader = () => {
  return (
    <section className="Loading-Container">
      <div>
        <img src={logo} alt="logo" />
      </div>
      <div>
        <Spinner animation="grow" variant="warning" />
        <Spinner animation="grow" variant="warning" />
        <Spinner animation="grow" variant="warning" />
      </div>
    </section>
  );
};

export default Loader;
